import PATHS from '@/routes/paths'
import { getNotesAsThreadNavItems } from '@/features/notes/demo/notesRailDemoData'
import { normalizeMessages } from '@/features/chat/messageNormalize'
import { collectExchangeIds } from './collectExchangeIds'
import { clearExchangeVersions } from './clearExchangeVersions'

/** @param {Record<string, unknown>} ctx */
export function purgeThreadOnDelete(ctx) {
  const {
    tid,
    messagesByThreadId,
    chatAbortRef,
    setThreads,
    setPinnedThreadIds,
    setMessagesByThreadId,
    setSelectedThreadId,
    setDismissedNoteThreadIds,
    urlThreadId,
    navigate,
  } = ctx
  const exchangeIds = collectExchangeIds(normalizeMessages(messagesByThreadId[tid] ?? []))
  chatAbortRef.current?.abort()
  clearExchangeVersions({ ...ctx, exchangeIds })
  setThreads((prev) => prev.filter((t) => t.id !== tid))
  setPinnedThreadIds((prev) => prev.filter((id) => id !== tid))
  setMessagesByThreadId((prev) => {
    const next = { ...prev }
    delete next[tid]
    return next
  })
  setSelectedThreadId((current) => (current === tid ? null : current))
  if (getNotesAsThreadNavItems().some((n) => n.id === tid)) {
    setDismissedNoteThreadIds((prev) => (prev.includes(tid) ? prev : [...prev, tid]))
  }
  if (urlThreadId === tid) navigate(PATHS.HOME, { replace: true })
}
